import PropTypes from 'prop-types';
// @mui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { IconButton, Stack } from '@mui/material';
import Iconify from '../iconify';

// ----------------------------------------------------------------------

export default function ConfirmDialog({ 
  title, 
  content, 
  action,
  closeAction,
  displayCloseIcon=false,
  open, 
  onClose, 
  hideAction=false,
  ...other 
}) {
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose} {...other}>
      <DialogTitle sx={{ pb: 2 }}>
        <Stack
          direction='row'
          justifyContent='space-between'
          alignItems='start'
        >
          {title}

          {
            displayCloseIcon
            ?
            <IconButton
              onClick={onClose}
            >
              <Iconify icon="material-symbols:close"/>
            </IconButton>
            :
            <></>
          }
        </Stack>  
      </DialogTitle>

      {content && <DialogContent sx={{ typography: 'body2' }}> {content} </DialogContent>}

      <DialogActions
        sx={{
          display: hideAction ? 'none' : 'flex'
        }}
      >
        {action}

        {
          closeAction
          ?
          closeAction
          :
          <Button variant="outlined" color="inherit" onClick={onClose}>
            Cancel
          </Button>
        }
      </DialogActions>
    </Dialog>
  );
}

ConfirmDialog.propTypes = {
  action: PropTypes.node,
  closeAction: PropTypes.node,
  content: PropTypes.node,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
  displayCloseIcon: PropTypes.bool,
  hideAction: PropTypes.bool
};
